import { isDataLayersArtificialBoundaryTerritoryGroup } from '~/sidebar/sidebarApps/mapTools/dataLayersTool/dataLayersTool.helpers';
import type { DemographicIdCode } from '~/store/boundaryGroups/boundaryGroups.repository';
import { BoundaryTerritoryType } from '~/store/boundaryTerritoryGroups/boundaryTerritoryGroup.type';
import type { BoundaryTerritoryGroup } from '~/store/boundaryTerritoryGroups/boundaryTerritoryGroups.state';
import type { DataLayerGroupId } from '~/store/mapSettings/data/dataLayers/mapSettingsDataLayers.state';

export const isBTGForDataLayer = (
  dataLayerGroupId: DataLayerGroupId,
  boundaryTerritoryGroup: BoundaryTerritoryGroup
): boolean => {
  return isDataLayersArtificialBoundaryTerritoryGroup(boundaryTerritoryGroup)
    && boundaryTerritoryGroup.settings.connectedEntityData?.id === dataLayerGroupId;
};

export const isBTGForDataLayerDemographic = ({
  dataLayerGroupId,
  demographic,
  boundaryTerritoryGroup,
}: Readonly<{
  dataLayerGroupId: DataLayerGroupId;
  demographic: DemographicIdCode;
  boundaryTerritoryGroup: BoundaryTerritoryGroup;
}>): boolean => {
  return isBTGForDataLayer(dataLayerGroupId, boundaryTerritoryGroup)
    && boundaryTerritoryGroup.settings.boundaryTerritoryType === BoundaryTerritoryType.Demographic
    && boundaryTerritoryGroup.settings.demographicId === demographic;
};
